/**
 * 全球指数成分股
 */
import React, { useEffect, useState } from "react"
import { getIndexCFGData } from "../../../../modules/quote/web"
import { LoadStatus } from "../../load_status"
import { quote_item_cfg_info, quote_cfg_info } from "../../quotedata/index"

export function GlobalIndexConstituentStock(props: { quotecode: string }) {
  const [stockList, setStockList] = useState<any>({total:0,diff:{}})
  const [newSort, setNewSort] = useState(false)
  const [zfSort, setZFSort] = useState(false)
  const [iconVisible,setIconVisible] = useState(false)
  const [param, setParam] = useState({ cmd: "", pindex: 1, psize: 10, sr: 1, st: "f3" })

  const onNewSort = () => {
    setIconVisible(true)
    setZFSort(false)
    let temp = param
    temp.st = "f2"
    if (!newSort) {
      setNewSort(true)
      temp.sr = 0
    } else {
      setNewSort(false)
      temp.sr = 1
    }
    setParam(temp)
  }

  const onZFSort = () => {
    setIconVisible(false)
    setNewSort(false)
    let temp = param
    temp.st = "f3"
    if (!zfSort) {
      setZFSort(true)
      temp.sr = 0
    } else {
      setZFSort(false)
      temp.sr = 1
    }
    setParam(temp)
  }

  const loadMore = () => {
    let temp = param
    temp.psize += 10
    setParam({
      ...temp
    })
  }

  const getCFGData = async (quotecode:string,param:any) => {
    let data = await getIndexCFGData(quotecode, param)
    if (data) {
      setStockList(data)
    }
  }

  useEffect(() => {
    getCFGData(props.quotecode, param)
    let timer = setInterval(() => {
      getCFGData(props.quotecode, param)
    }, 30 * 1000)
    return () => {
      timer && clearInterval(timer)
    }
  }, [param.psize,param.sr,param.st])

  return (
    <dl className="comm-stock-list report-list">
      <dd className="list-head">
        <div>名称代码</div>
        <div onClick={onNewSort}>
          最新<span className="blue">{!iconVisible?"":newSort ? "↑" : "↓"}</span>
        </div>
        <div onClick={onZFSort}>
          涨幅<span className="blue">{iconVisible?"":zfSort ? "↑" : "↓"}</span>
        </div>
      </dd>
      <div>
        {stockList.total > 0 &&
          Object.keys(stockList.diff).map((key: any) => {
            let item = stockList.diff[key]
            return (
              <dd key={key}>
                <a href={`/quote/stock/${item.f13}.${item.f12}.html`}>
                  <div>
                    {quote_cfg_info[quote_item_cfg_info.名称](item)}
                    {quote_cfg_info[quote_item_cfg_info.股票代码](item)}
                  </div>
                  {quote_cfg_info[quote_item_cfg_info.最新价](item)}
                  {quote_cfg_info[quote_item_cfg_info.涨跌幅](item)}
                </a>
              </dd>
            )
          })}
      </div>
      {
        stockList.total >= param.psize && 
        <div className="comm-more" onClick={(e)=>{e.preventDefault();loadMore()}}>
        <a href="#">加载更多</a>
      </div>
      }
      {stockList.total == 0 && <LoadStatus icon={false} className="com_tips" title="暂无数据" />}
      {stockList.total > 0 && stockList.total < param.psize && <LoadStatus icon={false} className="com_tips" title="已经加载到底了" />}
    </dl>
  )
}
